<template>
    <div class="o-qr-code-generator qr-code-generator" ref="qr" />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import qrcode from 'qrcode-generator';

export default {
    name: 'OQrGenerator',
    computed: {
        ...mapState({
            mapId: state => state.map.id,
            activeLocale: state => state.activeLocale,
        }),
        ...mapGetters([
            'getObject',
            'getTerminalId',
        ]),
        itemId() {
            return parseInt(this.$route.params.id, 10);
        },
        item() {
            return this.getObject(this.itemId);
        },
        type() {
            return this.item?.type === 'tenant' ? 'care' : 'service';
        }
    },
    mounted() {
        this.generateCode();
    },
    methods: {
        generateCode() {
            const typeNumber = 0;
            const errorCorrectionLevel = 'L';
            const from =  this.getTerminalId || this.$route.query.from || '';
            const qr = qrcode(typeNumber, errorCorrectionLevel);
            // if not a localhost force https
            const origin = location.origin.includes('192.168.') ? location.origin : location.origin.replace('http://', 'https://');
            const url = this.item ? 
                origin+ '/' + `map-${this.mapId}/mobile/guide/${this.type}?to=${this.itemId}&from=${from}&lang=${this.activeLocale}&redirect-from=qr` 
                : origin + '/' + `map-${this.mapId}/mobile`
            qr.addData(url);
            qr.make();
            this.$refs.qr.innerHTML = qr.createSvgTag({ margin: 0});

        }
    }
}
</script>

<style lang="scss" src="./o-qr-code-generator.scss" />
